(function (history) {
  const pushState = history.pushState;
  const replaceState = history.replaceState;
  const productWrapper = document.querySelector(".main-product");
  const urlLoad = new URL(window.location.href);
  const galleryModal = document.querySelector(`product-modal.variant-modal`);

  if (!urlLoad.searchParams.has("variant")) {
    if (
      productWrapper &&
      productWrapper.querySelector(".has-variant-gallery")
    ) {
      if (galleryModal) {
        galleryModal.classList.add("show-default");
      }

      const checkedInput = productWrapper
        .querySelector(".color-option")
        ?.querySelector("input:checked");
      if (checkedInput) {
        checkedInput.checked = false;
      }
    }
  } else {
    const variant = urlLoad.searchParams.get("variant");
    productWrapper
      .querySelector(".has-variant-gallery")
      .classList.add("variant-gallery-shown");

    if (productWrapper.querySelector(`.gallery-${variant}`)) {
      productWrapper
        .querySelector(`.gallery-${variant}`)
        .classList.add("active");
    } else {
      productWrapper
        .querySelector(".has-variant-gallery")
        .classList.remove("variant-gallery-shown");
    }
  }

  function handleUrlChange(event) {
    const data = event?.detail;

    let variant = data?.galleryId;

    if (variant) {
      const url = new URL(window.location.href);
      fetch(`${url}?variant=${variant}&section_id=main-product`)
        .then((res) => res.text())
        .then((html) => {
          const parser = new DOMParser();
          const section = parser.parseFromString(html, "text/html");
          if (section.querySelector(`.variant-gallery-view`)) {
            const modal = document.querySelector(`product-modal`);
            const modalContent = modal?.querySelector(
              `.product-media-modal__content.variant--view`
            );

            const newModalContent = section.querySelector(
              `product-modal .product-media-modal__content.variant--view`
            );

            if (modalContent && newModalContent) {
              modalContent.innerHTML = newModalContent.innerHTML;
            }
          }
        });
    }

    if (!data) {
      const url = new URL(window.location.href);
      if (url.searchParams.has("variant")) {
        variant = url.searchParams.get("variant");
      }
    }

    productWrapper
      .querySelector(".has-variant-gallery")
      .classList.add("variant-gallery-shown");
    productWrapper.querySelectorAll("media-gallery").forEach((gallery) => {
      gallery.classList.remove("active");
    });

    if (productWrapper.querySelector(`.gallery-${variant}`)) {
      productWrapper
        .querySelector(`.gallery-${variant}`)
        .classList.add("active");
    } else {
      productWrapper
        .querySelector(".has-variant-gallery")
        .classList.remove("variant-gallery-shown");
    }

    if (galleryModal) {
      galleryModal.classList.remove("show-default");
    }
  }

  history.pushState = function () {
    pushState.apply(history, arguments);
    handleUrlChange();
  };

  history.replaceState = function () {
    replaceState.apply(history, arguments);
    handleUrlChange();
  };

  window.addEventListener("popstate", handleUrlChange);
  window.addEventListener("b2bGalleryChange", handleUrlChange);
})(window.history);

document.addEventListener("DOMContentLoaded", function () {
  const galleryWrapper = document.querySelector(".variant-gallery-view");
  galleryWrapper
    .querySelector(".default-gallery")
    ?.classList.remove("loading--class");
  if (galleryWrapper) {
    let images = galleryWrapper.querySelectorAll("media-gallery [data-src]");
    images.forEach((image) => {
      image.setAttribute("src", image.getAttribute("data-src"));
    });
  }
});
